import React from 'react'
import ReactDOM from 'react-dom/client'
import './i18n'
import './styles.css'
import App from './app'
import { AppErrorBoundary } from './components/AppErrorBoundary'

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Root element not found')
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </React.StrictMode>,
)
